import React from 'react'

const ChatWhite = () => {
  return (
    <svg viewBox="0 0 58 37">
      <g>
        <path
          fill="#FFFFFF"
          d="M24.5,6.8C23,4.1,18.6,2,13.5,2C7.3,2,2,5.1,2,8.8c0,1.8,1.3,3.6,3.6,4.9C6,14,6.2,14.5,6,14.9l-0.9,2.4
            l2.9-2.1c0.2-0.2,0.5-0.2,0.8-0.2c1.5,0.4,3,0.6,4.6,0.6c0.9,0,1.8-0.1,2.7-0.2l0.1,2c-0.9,0.1-1.8,0.2-2.8,0.2
            c-1.5,0-3.1-0.2-4.6-0.5l-5.1,3.7C3.6,20.9,3.4,21,3.2,21c-0.2,0-0.4-0.1-0.6-0.2c-0.3-0.3-0.5-0.7-0.3-1.1L3.9,15
            C1.4,13.4,0,11.2,0,8.8C0,3.9,5.9,0,13.5,0C19.2,0,23.9,2.2,26,5.4L24.5,6.8z"
        />
        <path
          fill="#FFFFFF"
          d="M19.6,37c-0.2,0-0.4-0.1-0.6-0.2c-0.4-0.3-0.5-0.7-0.4-1.1l2.9-8.3C17.4,24.7,15,21,15,17.2
            C15,9.4,24.6,3,36.5,3C48.4,3,58,9.4,58,17.2c0,7.8-9.6,14.2-21.5,14.2c0,0,0,0-0.1,0c-2.6,0-5.1-0.3-7.6-0.9l-8.7,6.4
            C20,36.9,19.8,37,19.6,37z M36.5,5C25.7,5,17,10.5,17,17.2c0,3.4,2.3,6.6,6.2,8.9c0.4,0.2,0.6,0.7,0.4,1.2l-2.1,6l6.4-4.8
            c0.2-0.2,0.6-0.2,0.8-0.2c2.5,0.7,5,1,7.6,1c0,0,0,0,0.1,0c10.8,0,19.5-5.5,19.5-12.2S47.3,5,36.5,5z"
        />
      </g>
    </svg>
  )
}

export default ChatWhite
